import { Controller } from "remult";

@Controller("association-methods")
export class AssociationMethods {}
